import { SpecificRule } from "../../types/RuleTypes";

/**
 * Parses a specific rule of type "on_the" and returns a string representation.
 * @param rule the OnThe rule to parse
 * @returns human-readable string representation of the rule
 */
export function parseType_OnThe(rule: SpecificRule<"on_the">): string {
  const period = rule.period?.replace(/_/g, " ") ?? "";
  // if the periodType is set, no specific values are set. so we return the periodType and period
  if (rule.relativeTime) return `${rule.relativeTime} ${period}`;

  const { numberRange } = rule;

  if (!numberRange) return "ERROR: No number range provided"; // when the periodType is not set, a number range is required

  // if we have a "through" operator, we return the start and end values with the period
  if (numberRange.operator === "-" && numberRange.end)
    return `${numberRange.start}${numberRange.operator}${numberRange.end} ${period}`;

  // if we have a comma operator, we return the rangeEnd values and the start value with the period
  // we need to sort the values to ensure they are in ascending order, otherwise the cron expression will not be valid
  if (numberRange.operator === ",") {
    const range = [...(numberRange.rangeEnd ?? []), numberRange.start].sort(
      (a, b) => a - b
    );
    return `${range?.join(",")} ${period}`;
  }

  // if we only have a start value, we return the start value with the period
  return `${numberRange.start} ${period}`;
}
